import { useEffect, useRef } from "react";

export default function useTilt3D(maxTilt = 12) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const onMove = (e) => {
      const rect = el.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;

      el.style.transform = `
        perspective(800px)
        rotateX(${-y * maxTilt}deg)
        rotateY(${x * maxTilt}deg)
        translateZ(8px)
      `;
    };

    const onLeave = () => {
      el.style.transform =
        "perspective(800px) rotateX(0deg) rotateY(0deg) translateZ(0)";
    };

    el.addEventListener("mousemove", onMove);
    el.addEventListener("mouseleave", onLeave);

    return () => {
      el.removeEventListener("mousemove", onMove);
      el.removeEventListener("mouseleave", onLeave);
    };
  }, [maxTilt]);

  return ref;
}
